module.exports = __webpack_public_path__ + "static/media/top_shape_2.76a1a737.svg";